// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Box, Text, Button } from 'Common/components';
import CountdownCircle from 'Browser/components/CountdownCircle';
import { cancelNextBingeEpisode } from 'Common/player/actions';
import { analyticsBingeWatchingPlayNextOrCancelSelected } from 'Common/analytics/sharedAnalytics/actions';
import type { Episode } from 'Common/franchise/types';

const styles = {
  bingeMessage: (rightMargin: number) => () => ({
    position: 'absolute',
    bottom: 100,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    width: 300,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    padding: 10,
    right: rightMargin,
  }),
  dataContainer: () => ({
    flexDirection: 'column',
    marginLeft: 10,
    flex: 1,
  }),
  buttonsContainer: () => ({
    marginTop: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
  }),
  button: () => ({
    width: 95,
    backgroundColor: '#333333',
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    borderRadius: 2,
  }),
  buttonText: () => ({
    color: 'white',
  }),
  seasonText: () => ({
    color: 'white',
    fontWeight: 'bold',
    fontSize: 16,
  }),
  episodeText: () => ({
    color: 'white',
    fontSize: 14,
  }),
};

type Props = {
  bingeWatching: {
    isBingeWatchingCanceled: boolean,
    messageData: {
      nextEpisode: Episode,
      timeLeft: number,
    },
  },
  isMiniPlayer: boolean,
  rightMargin: number,
  onPlayNow: () => void,
  cancelNextBingeEpisode: (clearData: boolean) => void,
  exitFullscreen: () => void,
  analyticsBingeWatchingPlayNextOrCancelSelected: typeof analyticsBingeWatchingPlayNextOrCancelSelected,
};

class BingeWatchingMessage extends Component<Props> {
  componentDidUpdate(prevProps: Props) {
    const {
      bingeWatching: { messageData: prevMessageData },
    } = prevProps;
    const {
      bingeWatching: { messageData, isBingeWatchingCanceled },
      exitFullscreen,
    } = this.props;

    if (!prevMessageData && messageData && !isBingeWatchingCanceled) {
      exitFullscreen();
    }
  }

  hideBingeMessage = () => {
    const { cancelNextBingeEpisode } = this.props;
    cancelNextBingeEpisode(false);
    cancelNextBingeEpisode(true);
  };

  sendBingeWatchingAnalitycs = isNextEpisodeCanceled => {
    const {
      analyticsBingeWatchingPlayNextOrCancelSelected,
      bingeWatching: { messageData },
    } = this.props;

    const {
      nextEpisode: {
        season_number: seasonNumber = ' unknown',
        episode_number: episodeNumber = ' unknown',
        episode_name: episodeName,
        franchise_name: franchiseName,
      },
      timeLeft,
    } = messageData;

    analyticsBingeWatchingPlayNextOrCancelSelected(
      isNextEpisodeCanceled,
      franchiseName || '',
      episodeName || '',
      seasonNumber || '',
      episodeNumber || '',
      timeLeft,
    );
  };

  render() {
    const {
      bingeWatching: { messageData, isBingeWatchingCanceled },
      onPlayNow,
      isMiniPlayer,
      rightMargin,
    } = this.props;

    if (!messageData || isBingeWatchingCanceled || isMiniPlayer) return null;

    const {
      nextEpisode: {
        season_number: seasonNumber = ' unknown',
        episode_number: episodeNumber = ' unknown',
        episode_name: episodeName,
      },
      timeLeft,
    } = messageData;

    return (
      <Box style={styles.bingeMessage(rightMargin)}>
        <CountdownCircle seconds={timeLeft} />
        <Box style={styles.dataContainer}>
          <Text style={styles.seasonText}>{`Up Next: S${seasonNumber} Ep${episodeNumber}`}</Text>
          <Text style={styles.episodeText}>{episodeName}</Text>
          <Box style={styles.buttonsContainer}>
            <Button
              style={styles.button}
              onPress={() => {
                onPlayNow();
                this.sendBingeWatchingAnalitycs(false);
              }}
            >
              <Text style={styles.buttonText}>Play Now</Text>
            </Button>
            <Button
              style={styles.button}
              onPress={() => {
                this.hideBingeMessage();
                this.sendBingeWatchingAnalitycs(true);
              }}
            >
              <Text style={styles.buttonText}>Cancel</Text>
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default connect(
  state => ({
    bingeWatching: state.player.bingeWatching,
    isMiniPlayer: state.player.miniPlayer,
  }),
  { cancelNextBingeEpisode, analyticsBingeWatchingPlayNextOrCancelSelected },
)(BingeWatchingMessage);
